import { dashboardStatsSchema } from "@redotech/redo-model/disputes/dispute-analytics";
import * as z from "zod/v4";

export const getDisputeDashboardStats = {
  name: "getDisputeDashboardStats" as const,
  input: z.object({}),
  output: dashboardStatsSchema,
};
